import cn from 'classnames';
import { Button } from 'src/components/Button';
import { Link } from 'src/components/Link';

import s from './MlSpaceReviewSlide.module.scss';

function CasesButton({
  buttonLink,
  buttonTitle,
  className = '',
}: {
  buttonTitle: string;
  buttonLink: string;
  className?: string;
}) {
  return (
    <Link href={buttonLink} className={cn('link', s.btn, className)} withButton>
      <Button
        fontSize="default"
        id={`mlspace-cases-button-${buttonTitle}`}
        analyticsOptions={{
          action: buttonLink,
          clickZone: 'body',
          clickElement: 'button',
          clickContent: buttonTitle,
          uniqueId: `mlspace-cases-button-${buttonTitle}`,
          transitionType: 'inside-link',
          clickZoneCategory: 'site-body',
          transitionUrl: buttonLink,
          transitionTypeMetrics: 'internal',
        }}
      >
        {buttonTitle}
      </Button>
    </Link>
  );
}

interface MlspaceReviewSlideProps {
  title: string;
  text: string;
  buttonTitle: string;
  buttonLink: string;
}

export function MlspaceReviewSlide({
  title,
  text,
  buttonTitle,
  buttonLink,
}: MlspaceReviewSlideProps) {
  return (
    <div className={s.root}>
      <div className={s.leftSide}>
        <span className={s.title}>{title}</span>
        <CasesButton buttonLink={buttonLink} buttonTitle={buttonTitle} />
      </div>
      <div className={s.text} dangerouslySetInnerHTML={{ __html: text }} />
      <CasesButton
        buttonLink={buttonLink}
        buttonTitle={buttonTitle}
        className={s.btnMob}
      />
    </div>
  );
}
